/**
 * Brand DNA slice of the English catalog (V38) — the email signature card and
 * the business-kind-aware copy on the General tab and its preview.
 *
 * `{place}` is the kind's noun for where the brand shows up ("store",
 * "business", "product", …); `{Place}` is the same noun capitalised.
 */
export const enBrand = {
  'brandDna.title': 'Brand DNA',
  'brandDna.subtitle': 'Voice, identity, team, and messaging for your brand.',

  'brandDna.signature.title': 'Email signature',
  'brandDna.signature.help':
    'Added to the end of your flow and campaign emails, above the unsubscribe footer. Leave it empty for no signature.',
  'brandDna.signature.placeholder': 'Dana Cohen\nFounder, Your Business',
  'brandDna.signature.save': 'Save signature',
  'brandDna.signature.saving': 'Saving…',
  'brandDna.signature.saved': 'Signature saved',
  'brandDna.signature.saveFailed': 'Could not save your signature. Check your connection and try again.',
  'brandDna.signature.loadFailed': 'Could not load your signature. Refresh the page to try again.',

  'brandDna.basics.title': '{Place} Basics',
  'brandDna.basics.name': '{Place} Name',
  'brandDna.basics.namePlaceholder': 'Your {Place} Name',
  'brandDna.basics.url': '{Place} URL',
  'brandDna.basics.saved': '{Place} basics saved',
  'brandDna.logo.title': '{Place} Logo',
  'brandDna.logo.alt': '{Place} logo',
  'brandDna.logo.uploadCta': 'Upload PNG logo',
  'brandDna.logo.uploadHint': 'Exactly 512×512px · PNG only · Max 5MB',
  'brandDna.logo.urlLabel': 'Or paste logo URL',
  'brandDna.logo.saved': 'Logo saved',
  'brandDna.logo.save': 'Save Changes',
  'brandDna.logo.saving': 'Saving…',
  'brandDna.logo.clear': 'Clear',
  'brandDna.basics.currencyPlaceholder': 'Select currency',
  'brandDna.preview.taglinePlaceholder': 'Your tagline appears here',
  'brandDna.preview.note': 'This preview shows how your brand settings will appear across your {place}.',
} as const;
